<template>
    <div class="my-service">
        <mt-header fixed title="服务记录">
            <router-link to="/my" slot="left">
                <mt-button icon="back">返回</mt-button>
            </router-link>
        </mt-header>
        <div class="my-content">
            <mt-navbar v-model="selected">
                <mt-tab-item id="个体服务">个体服务</mt-tab-item>
                <mt-tab-item id="群体服务">群体服务</mt-tab-item>
                <mt-tab-item id="专业服务">专业服务</mt-tab-item>
            </mt-navbar>
            <div class="community-search">
                <div class="search-content">
                    <input class="search" placeholder="搜索老人姓名" v-model="search" />
                    <i class="mintui mintui-search"></i>
                </div>
                <div class="search-filter" @click="showHideSearch">
                    高级搜索
                </div>
            </div>
            <div class="advance-search" v-if="showAdvanceSearch">
                <mint-select selectLabel="服务类别" selectPatch="small_type" :selectValue="small_type" :slots="typeSlots" @changeValue="changeValue"></mint-select>
                <mt-field label="主题" placeholder="请输入活动主题" v-model="title"></mt-field>
                <mt-field label="起始时间" placeholder="请输入起始时间" type="date" v-model="begin_time"></mt-field>
                <mt-field label="结束时间" placeholder="请输入结束时间" type="date" v-model="end_time"></mt-field>
                <div class="search-form-button" @click="advanceSearch">
                    <a>搜索</a>
                </div>
            </div>
            <div class="content-body">
                <mt-tab-container v-model="selected">
                    <mt-tab-container-item :id="type" v-for="type in typeList" v-if="type===selected">
                        <ul class="mui-table-view service-record-list" v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading" infinite-scroll-distance="0" infinite-scroll-immediate-check="false">
                            <!--li数据遍历循环部分-->
                            <li class="mui-table-view-cell service-block" v-for="item in list">
                                <div class="service-block-body">
                                    <div class="service-title">{{ item.title }} </div>
                                    <div class="service-tips">
                                        <span class="service-type">{{ item.type }}</span> <span class="action-time">{{ item.carry_time }}</span>
                                    </div>

                                    <div class="thumbnails my-gallery" v-if="item.thumb.length>0">
                                        <figure itemprop="associatedMedia" itemscope="itemscope" class="thumbnail" v-for ="item in item.thumb.slice(0,5)">
                                            <a itemprop="contentUrl" data-size="400x400" class="img-wrapper" :href="imgUrl+'uploads/'+item">
                                                <img itemprop="thumbnail" :src="imgUrl+'uploads/'+item" />
                                            </a>
                                        </figure>
                                    </div>

                                    <div class="service-footer">
                                        <div class="service-footer-elder" v-if="single_type_array.indexOf(item.type)>-1">服务对象：<span>{{ item.elder_name }}</span></div>
                                        <div class="service-footer-elder" v-if="single_type_array.indexOf(item.type)<0">参与人数：<span>{{ item.activity_number }}</span></div>
                                        <div class="service-footer-elder">执行员工：<span>{{ item.staff }}</span></div>
                                    </div>
                                </div>

                                <div class="service-form-button" v-if="item.staff_id==staff_id" @click="enterEdit(item.id)">
                                   编辑
                                </div>

                            </li>
                            <!--底部判断是加载图标还是提示“全部加载”-->
                            <li class="more_loading" v-show="queryLoading">
                                <mt-spinner class="spinner" type="fading-circle"  color="#ffcb01;" :size="25"></mt-spinner>
                            </li>
                            <li class="more_loading" v-show="!queryLoading">
                                <span class="loaded">已全部加载</span>
                            </li>
                        </ul>

                    </mt-tab-container-item>
                </mt-tab-container>


                <div class="pswp" tabindex="-1" role="dialog" aria-hidden="true">
                    <div class="pswp__bg"></div>
                    <div class="pswp__scroll-wrap">
                        <div class="pswp__container">
                            <div class="pswp__item"></div>
                            <div class="pswp__item"></div>
                            <div class="pswp__item"></div>
                        </div>
                        <!-- 预览区域顶部的默认UI，可以修改 -->
                        <div class="pswp__ui pswp__ui--hidden">
                            <div class="pswp__top-bar">
                                <!--  与图片相关的操作 -->
                                <div class="pswp__counter"></div>
                                <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
                                <!--将分享按钮去掉 -->
                                <!-- <button class="pswp__button pswp__button--share" title="Share"></button> -->
                                <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                                <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                                <div class="pswp__preloader">
                                    <div class="pswp__preloader__icn">
                                        <div class="pswp__preloader__cut">
                                            <div class="pswp__preloader__donut"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                                <div class="pswp__share-tooltip"></div>
                            </div>
                            <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
                            <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
                            <div class="pswp__caption">
                                <div class="pswp__caption__center"></div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>

    import PhotoSwipe from "photoswipe";
    import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
    import "photoswipe/dist/photoswipe.css";
    import "photoswipe/dist/default-skin/default-skin.css";
    import GlOBAL from "@/api/global"
    import mintSelect from '../../components/mintSelect.vue'

    export default{

        components: {
            'mint-select':mintSelect
        },

        data(){
            return {
                openid:JSON.parse(window.localStorage.getItem('UserInfo')).openid,
                staff_id:JSON.parse(window.localStorage.getItem('UserInfo')).id,
                selected:"个体服务",
                imgUrl:GlOBAL.imgUrl,
                typeList:['个体服务','群体服务','专业服务'],
                single_type_array : ["入户","电访","医疗","家政","个案工作"],

                showAdvanceSearch:false,
                search:'',

                title:'',
                begin_time:'',
                end_time:'',
                small_type:'',
                typeSlots: [
                    {
                        values: ["","入户","电访","医疗","家政"],
                        className: 'slot1',
                        textAlign: 'center'
                    }
                ],


                //初始化无限加载相关参数
                list:[],
                queryLoading: true,
                pageNum:1,
            }
        },

        created(){
           this.getService(this.selected,this.pageNum);
        },

        watch:{
            selected:{
                handler(){

                    this.pageNum = 1;

                    if(this.selected==='个体服务'){
                        this.typeSlots[0].values = ["","入户","电访","医疗","家政"];
                    }

                    if(this.selected==='群体服务'){
                        this.typeSlots[0].values = ["","便民活动","基础教育","康乐活动","志愿活动"];
                    }

                    if(this.selected==='专业服务'){
                        this.typeSlots[0].values = ["","个案工作","小组工作"];
                    }

                    this.search = '';
                    this.resetSearchForm();

                    this.queryLoading = true;
                    this.getService(this.selected,1,true);
                }
            },

            search:{
                handler(){

                    this.queryLoading = true;
                    this.getService(this.selected,1,true);
                }
            }
        },

        methods:{

            getService(type,page,changed = false){

                this.$indicator.open('加载中');

                this.$axios.get('/my/service?openid='+this.openid+'&type='+type+'&page='+page+'&small_type='+this.small_type+'&search='+this.search+'&begin_time='+this.begin_time+'&end_time='+this.end_time+'&title='+this.title)
                    .then(data => {

                        if (data.data.code === 'OK') {

                            if(changed){
                                this.list = data.data.data;
                            }else{
                                this.list = this.list.concat(data.data.data);
                            }

                            if(data.data.data.length<10){
                                this.queryLoading = false;
                            }
                        } else {
                            this.$toast(data.data.message);
                        }

                        this.$indicator.close();
                    });
            },

            resetSearchForm(){
                this.small_type = '';
                this.title = '';
                this.begin_time = '';
                this.end_time = '';
            },

            showHideSearch(){
                this.showAdvanceSearch = !this.showAdvanceSearch;
                this.resetSearchForm();
            },

            advanceSearch(){
                this.queryLoading = true;
                this.getService(this.selected,1,true);
            },

            enterEdit(id){
                this.$router.push('/my/serviceEdit/'+id);
            },

            //无限加载函数
            loadMore() {

                if(!this.queryLoading){
                    return;
                }

                this.pageNum++;
                this.getService(this.selected,this.pageNum);

            },

            changeValue(value){
                let props = value[0];
                this[props] = value[1];
            },


            //引入photoSwipe(可预览、滑动)
            initPhotoSwipeFromDOM(gallerySelector) {
                var parseThumbnailElements = function(el) {
                    var thumbElements = el.childNodes,
                        numNodes = thumbElements.length,
                        items = [],
                        figureEl,
                        linkEl,
                        size,
                        item
                    for (var i = 0; i < numNodes; i++) {
                        figureEl = thumbElements[i];
                        if (figureEl.nodeType !== 1) {
                            continue
                        }
                        linkEl = figureEl.children[0];
                        size = linkEl.getAttribute('data-size').split('x')
                        item = {
                            src: linkEl.getAttribute('href'),
                            w: parseInt(size[0], 10),
                            h: parseInt(size[1], 10)
                        };
                        if (figureEl.children.length > 1) {
                            item.title = figureEl.children[1].innerHTML
                        }
                        if (linkEl.children.length > 0) {
                            item.msrc = linkEl.children[0].getAttribute('src')
                        }
                        item.el = figureEl
                        items.push(item)
                    }
                    return items
                }
                var closest = function closest(el, fn) {
                    return el && (fn(el) ? el : closest(el.parentNode, fn))
                }
                var onThumbnailsClick = function(e) {
                    e = e || window.event
                    e.preventDefault ? e.preventDefault() : e.returnValue = false
                    var eTarget = e.target || e.srcElement
                    var clickedListItem = closest(eTarget, function(el) {
                        return (el.tagName && el.tagName.toUpperCase() === 'FIGURE')
                    });

                    if (!clickedListItem) {
                        return;
                    }
                    var clickedGallery = clickedListItem.parentNode,
                        childNodes = clickedListItem.parentNode.childNodes,
                        numChildNodes = childNodes.length,
                        nodeIndex = 0,
                        index
                    for (var i = 0; i < numChildNodes; i++) {
                        if (childNodes[i].nodeType !== 1) {
                            continue
                        }
                        if (childNodes[i] === clickedListItem) {
                            index = nodeIndex
                            break
                        }
                        nodeIndex++
                    }

                    if (index >= 0) {
                        openPhotoSwipe(index, clickedGallery)
                    }
                    return false;
                }
                var photoswipeParseHash = function() {
                    var hash = window.location.hash.substring(1),
                        params = {}
                    if (hash.length < 5) {
                        return params;
                    }
                    var vars = hash.split('&');
                    for (var i = 0; i < vars.length; i++) {
                        if (!vars[i]) {
                            continue
                        }
                        var pair = vars[i].split('=');
                        if (pair.length < 2) {
                            continue
                        }
                        params[pair[0]] = pair[1];
                    }
                    if (params.gid) {
                        params.gid = parseInt(params.gid, 10)
                    }
                    return params
                }

                var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
                    var pswpElement = document.querySelectorAll('.pswp')[0],
                        gallery,
                        options,
                        items
                    items = parseThumbnailElements(galleryElement);
                    options = {
                        history: false,
                        galleryUID: galleryElement.getAttribute('data-pswp-uid'),
                        getThumbBoundsFn: function(index) {
                            var thumbnail = items[index].el.getElementsByTagName('img')[0],
                                pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                                rect = thumbnail.getBoundingClientRect()
                            return { x: rect.left, y: rect.top + pageYScroll, w: rect.width }
                        }

                    }
                    if (fromURL) {
                        if (options.galleryPIDs) {
                            for (var j = 0; j < items.length; j++) {
                                if (items[j].pid == index) {
                                    options.index = j
                                    break
                                }
                            }
                        } else {
                            options.index = parseInt(index, 10) - 1
                        }
                    } else {
                        options.index = parseInt(index, 10)
                    }
                    if (isNaN(options.index)) {
                        return ''
                    }
                    if (disableAnimation) {
                        options.showAnimationDuration = 0
                    }

                    gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options)
                    gallery.init()
                }
                var galleryElements = document.querySelectorAll(gallerySelector)
                for (var i = 0, l = galleryElements.length; i < l; i++) {
                    galleryElements[i].setAttribute('data-pswp-uid', i + 1)
                    galleryElements[i].onclick = onThumbnailsClick
                }
                var hashData = photoswipeParseHash()
                if (hashData.pid && hashData.gid) {
                    openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true)
                }
            }

        },

        updated() {
            this.initPhotoSwipeFromDOM(".my-gallery");
        }
    }
</script>
<style scoped>
    .content-body{
        padding:20px;
    }

    .service-block{
        margin-bottom: 20px;
        background:#fff;
    }

    .service-block-body{
        padding:20px;
    }

    ul.service-record-list{
        margin:0
    }

    .service-title{
        font-size:14px;
    }

    .service-tips{
        padding:10px 0;
    }

    .service-tips span{
        font-size:12px;
    }

    .service-tips span.service-type{
        background:#ffcb01;
        color:#fff;
        padding:0 10px;
    }

    .service-form-button{
        text-align: center;
        background: #ffcb01;
        color: #fff;
        padding: 10px 0;
        font-size: 14px;
    }

    .service-thumb{
        padding: 10px 0;
    }

    .thumbnails {
        width: 100%;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-flex-wrap: wrap;
        -ms-flex-wrap: wrap;
        flex-wrap: wrap;
    }
    .thumbnails .thumbnail {
        position: relative;
        margin: 0 10px 10px 0;
        padding-right: 5px;
        /*flex:1;*/
        width:70px;
        box-sizing: border-box;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
        .thumbnails .thumbnail {
        }
    }
    .thumbnails .thumbnail .img-wrapper {
        position: relative;
        display: flex;
    }
    @media screen and (min-width: 768px) and (max-width: 1024px) {
        .thumbnails .thumbnail .img-wrapper {
        }
    }
    .thumbnails .thumbnail .img-wrapper img {
        /*width: 100%;*/
        /* max-width: 100%; */
        width:70px;
        height:70px;
        object-fit: cover;
    }


    .service-footer-elder{
        font-size:12px;
    }

    .community-search{
        background: #dedede;
        padding: 7px 20px;
        height: 30px;
        top:100px;
        display:flex;
        justify-content: space-between;
    }
    .search-content{
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: #fff;
        width: 78%;
        border-radius: 15px;
        height: 30px;
        line-height: 30px;
    }

    .search-content .search{
        font-size: small;
        width: 100%;
        border-radius: 20px;
        border: none;
        padding:0 20px;
    }

    .search-content .search:focus{
        outline: none;
    }

    .search-content i{
        padding-right:10px;
    }

    .search-filter{
        display:inline-block;
        font-size: 14px;
        line-height: 30px;
        color:#5a5a5a;
    }

    .advance-search{
        background:#fff;
        font-size: 14px!important;
    }

    .search-form-button{
        text-align: center;
        padding: 8px 0;
        background: #ffcb01;
        color: #fff;
    }


</style>


// WEBPACK FOOTER //
// src/pages/my/service.vue